import { PartListBE } from '../../partsupplierpru/shared/partsupplierpru.model';
export class MultiPartBE {
    MainPartId: number = -1;
    PartNo: string = "";
    IsMultiPart: boolean = true;
    ContainingParts: PartListBE[] = [];
}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/multipart-part/shared/multipart-part.model.ts